"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactFontawesome = _interopRequireDefault(require("react-fontawesome"));
var _ThemeService = require("../common/ThemeService");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ReportHeading(props) {
  var themeColor = (0, _ThemeService.getColor)();
  var themeTextColor = (0, _ThemeService.getTextColor)();
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "grid report-heading",
    style: {
      gridTemplateColumns: '25fr 1fr',
      padding: '10px 0',
      marginLeft: "10px",
      marginRight: '10px',
      marginTop: '-12px'
    }
  }, /*#__PURE__*/_react["default"].createElement("sapn", {
    "data-e2e": "heading" + props.gameType,
    style: {
      display: 'inline-block',
      margin: 0,
      'textTransform': 'capitalize'
    }
  }, props.gameType == 'tournament' ? /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement("span", {
    className: "headingCss hide_player_name_from_header  alwaysDisplay"
  }, /*#__PURE__*/_react["default"].createElement("b", {
    className: "gameReport"
  }, props.playerReports.summaryInfo[0].playerName.toLowerCase(), "'s ", props.i18next.t("lable.tournamentGameReport"))), /*#__PURE__*/_react["default"].createElement("span", null, " : ".concat(props.reportCardSetting.hitRange))) : /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement("span", {
    className: "headerwrapper"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "headingCss gameReport"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "headingCss hide_player_name_from_header "
  }, /*#__PURE__*/_react["default"].createElement("b", {
    className: "gameReport"
  }, props.playerReports.summaryInfo[0].playerName.toLowerCase(), "'s ")), props.gameType === 'cash' ? 'NLH Cash' : props.gameType === 'plo' ? 'PLO Cash' : props.gameType, " ", props.i18next.t("lable.gameReport"), " "), /*#__PURE__*/_react["default"].createElement("span", {
    className: "line_between_heading"
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: "dash_between_heading"
  }, '-'), /*#__PURE__*/_react["default"].createElement("span", {
    className: "report_heading_filters",
    style: {
      textAlign: "start"
    }
  }, props.reportCardSetting.hitType === "6-seater" ? "6-Max" : props.reportCardSetting.hitType, ", ", props.reportCardSetting.hitLevel === "All Level" ? props.i18next.t("lable.allStakes") : props.reportCardSetting.hitLevel, ", ", props.i18next.t("lable." + props.reportCardSetting.hitRange))))), /*#__PURE__*/_react["default"].createElement("button", {
    className: "btn btnHalo reportCardSettingBtn",
    "data-e2e": "reportSettings",
    onClick: props.onSettingsClick,
    style: {
      height: "33px",
      backgroundColor: themeColor,
      width: "33px",
      alignSelf: 'stretch',
      borderRadius: '4px',
      padding: '0',
      textAlign: 'center',
      lineHeight: '20px',
      marginLeft: "auto"
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome["default"], {
    name: "fa fa-filter",
    style: {
      color: themeTextColor,
      fontSize: '21px'
    }
  })));
}
var _default = ReportHeading;
exports["default"] = _default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/mygame-components/dist/ReportCards/ReportHeading.js
 ** module id = 658
 ** module chunks = 0
 **/